'use client';

import type { LinkSkeletonNode } from 'data-layer';
// Direct file imports on purpose: the session/partials barrels also export server components (…Streaming),
// which must not leak into this client bundle.
import { AccountSectionContent } from '../session/partials/accountSection/AccountSectionContent';
import { AccountSectionStreamingSkeleton } from '../session/partials/accountSection/AccountSectionStreamingSkeleton';
import { PixumEnvExtensionApplier } from '../session/partials/pixumEnv/PixumEnvExtensionApplier';
import { buildUserExtension } from '../session/partials/pixumEnv/buildUserExtension';
import { CLIENT_SESSION_STATUS, useClientSession } from 'hooks';

type SessionClientProps = {
  menuItems: LinkSkeletonNode[];
  signInText: string;
  myPixumText: string;
};

/**
 * SessionClient — client-only counterpart of SessionStreaming for every page that renders without a server session.
 *
 * Shows the account skeleton until the session is created or restored, then the account section and the
 * PIXUM_ENV.USER extension. The texts arrive already transformed from the data layer.
 */
export function SessionClient({ menuItems, signInText, myPixumText }: SessionClientProps) {
  const { status, isAuthenticated, uuid, sessionInfos, userData } = useClientSession();

  if (status === CLIENT_SESSION_STATUS.LOADING) {
    return <AccountSectionStreamingSkeleton />;
  }

  return (
    <>
      <PixumEnvExtensionApplier userExtension={buildUserExtension({ isAuthenticated, uuid, sessionInfos, userData })} />
      <AccountSectionContent
        isAuthenticated={isAuthenticated}
        email={userData?.email}
        menuItems={menuItems}
        signInText={signInText}
        myPixumText={myPixumText}
      />
    </>
  );
}
